export const isAndroid = navigator.userAgent.includes("Android");
